'use client';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import styles from './styles/OurValues.module.scss';

type AllTrailsValue = {
  value: string;
  desc: string;
};

const OurValues = () => {
  const intl = useIntl();
  const values: AllTrailsValue[] = [
    {
      value: intl.formatMessage({ defaultMessage: 'Positivity' }),
      desc: intl.formatMessage({ defaultMessage: 'We live for the joy of being outdoors, and our purpose is to share that joy with the world.' })
    },
    {
      value: intl.formatMessage({ defaultMessage: 'Innovation' }),
      desc: intl.formatMessage({ defaultMessage: 'We are always moving forward, fueled by the inspiration of our community.' })
    },
    {
      value: intl.formatMessage({ defaultMessage: 'Humility' }),
      desc: intl.formatMessage({ defaultMessage: 'Our actions are grounded in good intent, and we are driven by curiosity.' })
    },
    {
      value: intl.formatMessage({ defaultMessage: 'Adaptability' }),
      desc: intl.formatMessage({ defaultMessage: 'Change is the only constant. We’re at our best when we embrace the new and unexpected.' })
    },
    {
      value: intl.formatMessage({ defaultMessage: 'Stewardship' }),
      desc: intl.formatMessage({
        defaultMessage: 'Loving our planet means enjoying it responsibly and joining with others who work to protect it.'
      })
    },
    {
      value: intl.formatMessage({ defaultMessage: 'Inclusivity' }),
      desc: intl.formatMessage({ defaultMessage: 'We all belong outside. We commit to advancing equitable access to nature.' })
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={classNames(styles.textContainer, styles.title)}>
          <Heading as="h2" className={styles.header} size="500">
            {intl.formatMessage({ defaultMessage: 'Our values' })}
          </Heading>
          <Typography component="div" variant="text300">
            {intl.formatMessage({
              defaultMessage:
                'Our values guide our strategy, our work, and our team. Inspired by our best experiences on the trail and rooted in how we bring our mission to life everyday, these six values carry through our past, present, and future.'
            })}
          </Typography>
        </div>
        <div className={styles.textContainer}>
          {values.map((valueInfo: AllTrailsValue) => (
            <div className={styles.valueContainer} key={valueInfo.value.toLowerCase().split(' ').join('-')}>
              <Heading as="h3" className={styles.value} size="400">
                {valueInfo.value}
              </Heading>
              <Typography component="div" variant="text200" mb="16">
                {valueInfo.desc}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { OurValues as default };
export type { AllTrailsValue };
